<script setup lang="ts">
import { ref, onErrorCaptured } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const error = ref<Error | null>(null)

onErrorCaptured((err) => {
  error.value = err
  console.error('ErrorBoundary caught:', err)
  return false
})

function retry() {
  error.value = null
}
</script>

<template>
  <div v-if="error" class="flex flex-col items-center justify-center py-16 px-6">
    <div class="flex h-16 w-16 items-center justify-center rounded-full bg-red-100 dark:bg-red-900/30">
      <svg class="h-8 w-8 text-red-600 dark:text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    </div>
    <h3 class="mt-4 text-base font-semibold text-gray-900 dark:text-white">{{ t('common.error') }}</h3>
    <p class="mt-2 text-sm text-gray-500 dark:text-gray-400 text-center max-w-sm">{{ error.message }}</p>
    <button
      class="mt-6 rounded-lg bg-indigo-600 px-4 py-2 text-sm font-medium text-white hover:bg-indigo-500"
      @click="retry"
    >
      {{ t('common.retry') }}
    </button>
  </div>
  <slot v-else />
</template>
